import React from "react";

const Pages_Upload_Lcc = () => {
  return <div>Pages_Upload_Lcc</div>;
};

export default Pages_Upload_Lcc;
